import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./plus.svg?react";

export const PlusIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
